/* ===========================================================================
   IMAGE SOURCES  <<<  SWAP THESE  >>>
   ---------------------------------------------------------------------------
   Every image on the site resolves through this one file. To replace the
   placeholders with Vitality's real photography, change the URLs here and
   nothing else. No other file references an image directly.

   STATUS: the ten photographs below are Unsplash PLACEHOLDERS chosen to match
   the subject and tone of the originals in the Lovable build
   (src/assets/*.jpg). They are close in feel but they are not the real
   assets, and they are not licensed for Vitality's use beyond Unsplash's own
   terms. Replace before this goes anywhere public.

   The logo is NOT a placeholder. It is the real mark, served from the
   Vitality Foundation design system in Magic Patterns, so it is stable.
   =========================================================================== */

const unsplash = (id: string, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

/** The real Vitality mark. Hosted by the Magic Patterns design system. */
export const LOGO =
  'https://cdn.magicpatterns.com/design-systems/ds-2db215f0-4f4c-4f63-99c7-6764a7e41c37/logos/3e29f530-9ace-4422-9a45-a1e55db4121c.png';

/** The five essentials. Square crops: these render inside circular masks. */
export const ESSENTIALS_IMG = {
  air: unsplash('1601297183305-6df142704ea2', 640),
  water: unsplash('1505142468610-359e7d316be0', 640),
  food: unsplash('1500382017468-9049fed747ef', 640),
  health: unsplash('1466781783364-36c955e42a7f', 640),
  materials: unsplash('1528459801416-a9e53bbf4e17', 640),
};

/** The multiplier row. Also circular masks, so square crops. */
export const MULTIPLIER_IMG = {
  material: ESSENTIALS_IMG.materials,
  sensor: unsplash('1518495973542-4542c06a5843', 640),
  machine: unsplash('1625246333195-78d9c38ad449', 640),
  solution: unsplash('1560493676-04071c5f467b', 640),
};

/** Leadership portraits. Square or portrait crops, faces in the upper third. */
export const PORTRAIT = {
  natalya: 'https://cdn.magicpatterns.com/uploads/tx82xy1DyHfCG3N3kde7xx/7_Natalya.jpg',
};

/** Full bleed photography. Wide crops. */
export const SCENE_IMG = {
  /** A single backlit aspen leaf. Left panel of the mission diptych: one idea. */
  aspenLeaf: 'https://cdn.magicpatterns.com/uploads/dsCDSzBLbyvECkSMKBtpDb/IMG_2545.jpg',
  /** An aspen grove: many trunks, one connected organism. Right panel of the diptych. */
  aspenGrove: 'https://cdn.magicpatterns.com/uploads/eDmYxwm61L57u4zjsDbQo2/IMG_2640.jpg',
  /** Alpine tundra: a dense red groundcover mat over rock and lichen. Soil at
      ground scale, behind the "Built like nature" band. */
  tundraSoil: 'https://cdn.magicpatterns.com/uploads/8c5tkB7YEqsQpe2CgDuvuX/IMG_2579.jpg',
  /** Mountains under a burning sunset. The closing band above the footer. */
  sunsetRidge: 'https://cdn.magicpatterns.com/uploads/4BYTUpyrqnqBb5Pu4zdcbF/IMG_2578.jpg',
  /** Granite peaks doubled in a still alpine lake. Held for future use. */
  windRiverLake: 'https://cdn.magicpatterns.com/uploads/wECkRf9bErYcP1SJXCNgzc/Wind_river_2.jpg',
};
